import React from 'react';
import {
    Select,
} from '@shopify/polaris';

export function MetafieldTypeFormElement(props) {

    const onValueChange = (value) => {
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.metafieldType = value;
        props.onChange(newSettings);
    }

    return (
        <Select
            label="Metafield Type"
            helpText={
                <span>
                    The type of the metafiled that will be populated. All metafields must have the same type.
                </span>
            }
            options={[
                {
                    'label': 'Single line text',
                    'value': 'single_line_text_field'
                },
                {
                    'label': 'Multi line text',
                    'value': 'multi_line_text_field'
                }
            ]}
            value={props.settings.metafieldType}
            error={props.settingsErrors["metafieldType"]}
            onChange={onValueChange}
        />
    );
}